var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNenhumaassinatura(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 552.88 619.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #6543fa;\n      }\n\n      .cls-2 {\n        stroke: #fff;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        fill: none;\n      }\n\n      .cls-2, .cls-4, .cls-5 {\n        stroke-width: 4.7px;\n      }\n\n      .cls-6 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        stroke-width: 5.03px;\n      }\n\n      .cls-3, .cls-4, .cls-5 {\n        stroke: #2d2165;\n      }\n\n      .cls-7 {\n        fill: #7041ff;\n      }\n\n      .cls-5, .cls-8 {\n        fill: #fcfdfd;\n      }\n\n      .cls-9 {\n        fill: #2d2165;\n      }\n\n      .cls-10 {\n        fill: #94d8f4;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M45.27,73.28h372.1c12.44,0,22.54,10.1,22.54,22.54v498.35c0,12.44-10.1,22.54-22.54,22.54H45.27c-12.44,0-22.54-10.1-22.54-22.54V95.82c0-12.44,10.1-22.54,22.54-22.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M439.91,103.47v-7.65c0-12.45-10.09-22.54-22.54-22.54H45.27c-12.45,0-22.54,10.09-22.54,22.54v7.65h417.18Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 41.24,
    y1: 87.69,
    x2: 48.95,
    y2: 87.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 57.57,
    y1: 87.69,
    x2: 65.28,
    y2: 87.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 73.91,
    y1: 87.69,
    x2: 81.62,
    y2: 87.69
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 107.42,
    cy: 287.12,
    r: 24.7,
    transform: "translate(-185.76 376.7) rotate(-86.48)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 107.42,
    cy: 355.98,
    r: 24.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 107.42,
    cy: 424.83,
    r: 24.7
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 140.89,
    y: 475.13,
    width: 318.38,
    height: 87.83,
    rx: 31.67,
    ry: 31.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M117.53,187.64h211.01c20.66,0,37.4,16.75,37.4,37.4v206.81"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "391.82 407.67 365.95 433.54 340.07 407.67"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 142.4,
    y1: 277.33,
    x2: 182.65,
    y2: 277.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 209.64,
    y1: 297.92,
    x2: 142.4,
    y2: 297.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 304.83,
    y1: 297.92,
    x2: 221.08,
    y2: 297.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 142.4,
    y1: 346.18,
    x2: 232.38,
    y2: 346.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 242.9,
    y1: 366.78,
    x2: 142.4,
    y2: 366.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 304.83,
    y1: 366.78,
    x2: 254.33,
    y2: 366.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 142.4,
    y1: 415.04,
    x2: 195.78,
    y2: 415.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 184.35,
    y1: 435.64,
    x2: 142.4,
    y2: 435.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 267.14,
    y1: 435.64,
    x2: 195.78,
    y2: 435.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 64.04,
    cy: 188.54,
    r: 64.04,
    transform: "translate(-114.56 100.5) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M242.76,514.3h4.54l3.24,11.97,3.53-11.71h3.9l3.51,11.71,3.25-11.97h4.54l-4.85,16.44h-5.46l-2.95-9.97-2.95,9.97h-5.46l-4.85-16.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M268.5,522.5c.02-5.02,3.58-8.55,8.46-8.55,4.52,0,7.96,3.03,7.96,8.01,0,.6-.05,1.22-.15,1.87h-11.88c.33,1.94,2.29,3.29,4.38,3.29,1.63,0,3.03-.75,4.09-2.31l3.12,2.33c-1.54,2.57-4.42,3.96-7.31,3.96-5.27,0-8.66-3.8-8.66-8.6ZM280.83,520.9c-.22-1.83-1.73-3.24-3.82-3.24s-3.82,1.37-4.06,3.24h7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M286.46,530.74v-24.11h4.32v9.66c1.08-1.37,2.77-2.33,5.41-2.33,4.66,0,7.96,3.54,7.96,8.55s-3.31,8.58-7.96,8.58c-2.41,0-4.28-.84-5.34-2.09l-.09,1.75h-4.3ZM295.3,527.15c2.6,0,4.45-2.05,4.45-4.66s-1.83-4.59-4.45-4.59-4.47,1.97-4.47,4.59,1.87,4.66,4.47,4.66Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M305.28,522.49c0-4.81,3.89-8.58,8.77-8.58,3.08,0,6.13,1.61,7.64,4.69l-3.34,2.12c-.96-1.9-2.64-2.77-4.23-2.77-2.64,0-4.47,2.02-4.47,4.62s1.88,4.54,4.4,4.54c1.78,0,3.27-.84,4.38-2.84l3.17,2.23c-1.51,3-4.57,4.59-7.65,4.59-4.93,0-8.66-3.8-8.66-8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M322.73,530.74v-24.11h4.4v9.42c.86-1.05,2.57-2.09,4.93-2.09,3.77,0,6.46,2.5,6.46,6.46v10.33h-4.4v-9.2c0-2.28-1.46-3.51-3.36-3.51s-3.63,1.23-3.63,3.51v9.2h-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M339.75,522.5c.02-5.02,3.58-8.55,8.46-8.55,4.52,0,7.96,3.03,7.96,8.01,0,.6-.05,1.22-.16,1.87h-11.88c.33,1.94,2.29,3.29,4.38,3.29,1.63,0,3.03-.75,4.09-2.31l3.12,2.33c-1.54,2.57-4.42,3.96-7.31,3.96-5.27,0-8.67-3.8-8.67-8.6ZM352.08,520.9c-.22-1.83-1.73-3.24-3.82-3.24s-3.82,1.37-4.06,3.24h7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M356.58,522.49c0-4.81,3.89-8.58,8.77-8.58,3.08,0,6.13,1.61,7.64,4.69l-3.34,2.12c-.96-1.9-2.64-2.77-4.23-2.77-2.64,0-4.47,2.02-4.47,4.62s1.88,4.54,4.4,4.54c1.78,0,3.27-.84,4.38-2.84l3.17,2.23c-1.51,3-4.57,4.59-7.65,4.59-4.93,0-8.66-3.8-8.66-8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M394.79,506.49c1.49,0,2.53,1.03,2.53,2.53s-1.05,2.52-2.53,2.52-2.52-1.03-2.52-2.52,1.03-2.53,2.52-2.53ZM392.62,530.74v-16.44h4.4v16.44h-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M399.53,530.74v-16.44h4.18l.09,1.9c.86-1.15,2.62-2.24,5.07-2.24,3.8,0,6.49,2.5,6.49,6.46v10.33h-4.38v-9.2c0-2.28-1.47-3.51-3.41-3.51s-3.65,1.23-3.65,3.51v9.2h-4.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M381,524.67c-.98.18-1.96.28-3.05.35v5.72h-4.45v-25.26h4.45v10.56c2.18-2.21,4.98-3.61,7.75-3.61,3.3,0,5.47,1.93,5.47,4.81s-2.11,4.98-5.86,6.35l-4.31,1.09ZM377.94,521.76c5.75-.56,9.23-2.1,9.23-4.1,0-.98-.84-1.61-2.21-1.61-2.28,0-5.19,1.65-7.02,4.07v1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M383.53,521.31l7.35,9.42h-5.43l-4.86-6.58"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M210.1,528.53c-1.69,0-3.28-.66-4.47-1.85l-3.55-3.55,3.92-3.92,3.55,3.55c.19.19.4.23.55.23s.36-.04.55-.23l8.14-8.14,3.92,3.92-8.14,8.14c-1.19,1.19-2.78,1.85-4.47,1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M224.85,537.74h-25.51c-4.64,0-8.42-3.78-8.42-8.42v-10.41c0-2.25.88-4.37,2.47-5.96l12.75-12.75c1.59-1.59,3.71-2.47,5.96-2.47s4.36.88,5.96,2.47l12.75,12.75c1.59,1.59,2.47,3.71,2.47,5.96v10.41c0,4.64-3.78,8.42-8.42,8.42ZM212.1,503.28c-.77,0-1.49.3-2.03.84l-12.75,12.75c-.54.54-.84,1.26-.84,2.03v10.41c0,1.58,1.29,2.87,2.87,2.87h25.51c1.58,0,2.87-1.29,2.87-2.87v-10.41c0-.77-.3-1.49-.84-2.03l-12.75-12.75c-.54-.54-1.26-.84-2.03-.84Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 63.15,
    y1: 153.74,
    x2: 63.15,
    y2: 166.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 63.15,
    y1: 208.83,
    x2: 63.15,
    y2: 221.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.26,187.64h-4.24c-5.83,0-10.59-4.77-10.59-10.59h0c0-5.83,4.77-10.59,10.59-10.59h4.24c5.83,0,10.59,4.77,10.59,10.59h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M61.03,187.64h4.24c5.83,0,10.59,4.77,10.59,10.59h0c0,5.83-4.77,10.59-10.59,10.59h-4.24c-5.83,0-10.59-4.77-10.59-10.59h0"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 404.9,
    cy: 147.99,
    r: 147.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M442.84,117.91l-32.93,15.8-15.8-32.93c-2.56-5.33-8.95-7.58-14.28-5.02-5.33,2.56-7.58,8.95-5.02,14.28l15.8,32.93-32.93,15.8c-5.33,2.56-7.57,8.96-5.01,14.29,2.56,5.32,8.94,7.57,14.27,5.02l32.93-15.8,15.8,32.93c2.56,5.33,8.96,7.57,14.29,5.01,5.32-2.56,7.57-8.94,5.02-14.27l-15.8-32.93,32.93-15.8c5.33-2.56,7.58-8.95,5.02-14.28s-8.95-7.58-14.28-5.02h0Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNenhumaassinatura);
export default __webpack_public_path__ + "static/media/Nenhuma assinatura.77c23f71aff3e8e2a5222f5298a4a7a2.svg";
export { ForwardRef as ReactComponent };